import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      // Path to your translations folder in the public directory
      loadPath: '/translations/{{lng}}/translation.json',
    },
    lng: 'mn', // Default language
    fallbackLng: 'mn', // Fallback language
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
